export const SealBarrierIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99856 1.99951L2.99951 4.49904V7.99837C2.99951 11.0978 5.09911 13.2974 7.99856 13.9972C10.898 13.2974 12.9976 11.0978 12.9976 7.99837V4.49904L7.99856 1.99951Z"
      stroke="currentColor"
      strokeWidth="1.29975"
      strokeLinejoin="round"
    />
    <path
      d="M5.99902 8.49878L7.49902 9.99878L10.499 6.49878"
      stroke="currentColor"
      strokeWidth="1.29975"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
